<button mat-stroked-button color="accent" footer (click)="deferAppointment()">
  {{ "Odgodi" | translate }}
</button>
